export default __webpack_public_path__ + "2821c22616a1bb9f0f81ef0134c749d2.png";